import React, { useState } from "react";
import styles from "./../Login.module.css";
import { apiUrl } from "../../../Constants/Constants";
import axios from "axios";
import { toast } from "react-toastify";
const ReferralCheck = ({
  changeStep,
  loading,
  setLoading,
  setReferralPassword,
  setReferralCode,
  referralCode,
  referralPassword,
  setLoginReferral,
}) => {
  const [steps, setSteps] = useState(1);
  const handleInput = (name, value) => {
    if (/^\d*$/.test(value)) {
      if (name === "referral") {
        setReferralCode(value);
      }
    }
    if (name === "password") {
      setReferralPassword(value);
    }
  };
  const checkReferralCode = async (e) => {
    e.preventDefault();

    if (referralCode !== "") {
      setLoading(true);
      try {
        const response = await axios.post(apiUrl + "referral/referral-check", {
          referralCode,
        });

        if (response.data.status === "200") {
          if (response.data?.data?.valid === true) {
            if (response.data?.data?.usable === true) {
              toast.success("لطفا رمز ریفرال را وارد نمایید.");
              setSteps(2);
            } else {
              toast.error("حد مجاز ریفرال به پایان رسیده");
            }
          }
        } else {
          toast.error("کد ریفرال یافت نشد.");
        }
      } catch (err) {
        toast.error("خطا در دریافت اطلاعات");
      } finally {
        setLoading(false);
      }
    }
  };

  const checkReferralCodePassword = async (e) => {
    setLoading(true);
    e.preventDefault();
    if (referralCode !== "" && referralPassword !== "") {
      try {
        const response = await axios.post(
          apiUrl + "referral/referral-password",
          {
            referralCode,
            referralPassword,
          }
        );

        if (response.data.status === "200") {
          if (response.data?.data?.valid === true) {
            toast.success("لطفا اطلاعات خود را وارد نمایید.");
            changeStep(2);
          }
        } else {
          toast.error("رمز ریفرال اشتباه است");
        }
      } catch (err) {
        console.error("Error sending OTP:", err);
      } finally {
        setLoading(false);
      }
    }
  };

  return (
    <>
      {steps == 1 && (
        <form className={styles.form} onSubmit={(e) => checkReferralCode(e)}>
          <div className={styles.inputGroup}>
            <input
              type="tel"
              required
              placeholder="کد ریفرال را وارد نمایید"
              className={styles.inputField}
              value={referralCode}
              onChange={(e) => handleInput("referral", e.target.value)}
            />
          </div>
          <div className={styles.boxactions}>
            <button type="submit" className={styles.loginButton}>
              بررسی کد ریفرال
            </button>
            <div
              className={styles.yellowCta}
              onClick={() => setLoginReferral(false)}
            >
              ورود با شماره همراه
            </div>
          </div>
        </form>
      )}
      {steps == 2 && (
        <form
          className={styles.form}
          onSubmit={(e) => checkReferralCodePassword(e)}
        >
          <div className={styles.acceptedRefferral}>
            {referralCode}
            <i className="fas fa-check-circle"></i>
          </div>
          <div className={styles.inputGroup}>
            <input
              type="password"
              required
              placeholder="رمز ریفرال را وارد نمایید"
              className={styles.inputField}
              value={referralPassword}
              onChange={(e) => handleInput("password", e.target.value)}
            />
          </div>
          <div className={styles.boxactions}>
            <button type="submit" className={styles.loginButton}>
              بررسی رمز ریفرال
            </button>
            <div
              className={styles.yellowCta}
              onClick={() => setLoginReferral(false)}
            >
              ورود با شماره همراه
            </div>
          </div>
        </form>
      )}
    </>
  );
};

export default ReferralCheck;
